// 请求模块
// 引入axios
import axios from 'axios'
import store from '@/store'
import { Toast } from 'vant'
import { remove } from '@/utils/storage'
const request = axios.create({
  baseURL: '/zqt'
})
// 请求拦截器
request.interceptors.request.use(
  function (config) {
    const token =
      (store.state.userInfo ? store.state.userInfo.token : '') ||
      localStorage.getItem('token') ||
      ''
    if (token) {
      config.headers.token = `${token}`
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)
request.interceptors.response.use(
  (response) => {
    const res = response
    if (res.data.code != 200) {
      if (res.data.code == 401) {
        Toast.fail(`${res.data.msg} 3秒后自动退出` || '请求错误')
        setTimeout(() => {
          remove('token')
          remove('userType')
          remove('openId')
          remove('url')
          remove('userInfo')
          // window.close();
          // 关闭安卓系统
          document.addEventListener(
            'WeixinJSBridgeReady',
            function () {
              WeixinJSBridge.call('closeWindow')
            },
            false
          )
          // 关闭ios系统
          WeixinJSBridge.call('closeWindow')
        }, 3000)
      } else {
        Toast.fail(`${res.data.msg}` || '请求错误')
      }
    }
    return res
  },
  (error) => {
    // Message.error(error.response.msg || error.response.status);
    // 这里还可以根据status值（401、500等）分别做对应的处理，比如记录当前请求url，登录以后自动跳转到原url
    return Promise.reject(error)
  }
)

export default request
